import controller from '../../../../Resources/Scripts/_Shared/controller';

function imageSlider(context) {

  const slider = document.querySelector('.facilitypage__main-info__images__slider');
  const sliderItems = context.querySelector('.facilitypage__main-info__images__wrapper');
  const prev = context.querySelector('.facilitypage__main-info__images__leftbutton');
  const next = context.querySelector('.facilitypage__main-info__images__rightbutton');
  const interval = (context.dataset.interval || 5) * 1000;

  if (!slider) return;

  const slide = (wrapper, items, prev, next) => {
    const slides = items.querySelectorAll('.facilitypage__main-info__images__image');
    const slidesLength = slides.length;
    const firstSlide = slides[0];
    const lastSlide = slides[slidesLength - 1];
    const cloneFirst = firstSlide.cloneNode(true);
    const cloneLast = lastSlide.cloneNode(true);
    const threshold = 100;

    let slideSize = wrapper.offsetWidth;
    let posX1 = 0;
    let posX2 = 0;
    let posInitial;
    let posFinal;
    let index = 0;
    let direction = 'next';
    let scrolled = false;
    let allowShift = true;

    const dragStart = (e) => {
      clearInterval(automaticSlide);
      e = e || window.event;
      e.preventDefault();
      posInitial = items.offsetLeft;

      if (e.type == 'touchstart') {
        posX1 = e.touches[0].clientX;
      } else {
        posX1 = e.clientX;
        document.onmouseup = dragEnd;
        document.onmousemove = dragAction;
      }
    }

    const dragAction = (e) => {
      if (automaticSlide) clearInterval(automaticSlide);
      e = e || window.event;

      if (e.type == 'touchmove') {
        posX2 = posX1 - e.touches[0].clientX;
        posX1 = e.touches[0].clientX;
      } else {
        posX2 = posX1 - e.clientX;
        posX1 = e.clientX;
      }
      items.style.left = (items.offsetLeft - posX2) + "px";
    }

    const dragEnd = (e) => {
      posFinal = items.offsetLeft;
      if (posFinal - posInitial < -threshold) {
        shiftSlide(1, 'drag');
      } else if (posFinal - posInitial > threshold) {
        shiftSlide(-1, 'drag');
      } else {
        items.style.left = (posInitial) + "px";
      }

      document.onmouseup = null;
      document.onmousemove = null;
    }

    const wheelAction = (e) => {
      if (scrolled) return;
      scrolled = true;
      e = e || window.event;
      if (e.deltaX > 0) {
        direction = 'next';
        shiftSlide(1);
      } else if (e.deltaX < 0) {
        shiftSlide(-1);
        direction = 'prev';
      }
      setTimeout(() => { scrolled = false }, 1000)
    }

    const shiftSlide = (dir, action) => {
      items.classList.add('shifting');
      slideSize = wrapper.offsetWidth;
      if (allowShift) {
        if (!action) { posInitial = items.offsetLeft; }

        if (dir == 1) {
          items.style.left = (posInitial - slideSize) + "px";
          index++;
        } else if (dir == -1) {
          items.style.left = (posInitial + slideSize) + "px";
          index--;
        }
      };

      allowShift = false;
    }

    const checkIndex = () => {
      items.classList.remove('shifting');
      slideSize = wrapper.offsetWidth;
      if (index == -1) {
        items.style.left = -(slidesLength * slideSize) + "px";
        index = slidesLength - 1;
      }

      if (index == slidesLength) {
        items.style.left = -(1 * slideSize) + "px";
        index = 0;
      }

      allowShift = true;
    }

    const automaticSlide = interval > 0 ? setInterval(() => {
      if (direction === 'next') shiftSlide(1);
      else shiftSlide(-1);
    }, interval) : null;

    // Clone first and last slide
    items.appendChild(cloneFirst);
    items.insertBefore(cloneLast, firstSlide);
    wrapper.classList.add('loaded');

    // Mouse events
    items.onmousedown = dragStart;

    // Touch events
    items.addEventListener('touchstart', dragStart);
    items.addEventListener('touchend', dragEnd);
    items.addEventListener('touchmove', dragAction);
    items.addEventListener('wheel', wheelAction);

    // Click events
    prev.addEventListener('click', () => { direction = 'prev'; shiftSlide(-1) });
    next.addEventListener('click', () => { direction = 'next'; shiftSlide(1) });

    // Transition events
    items.addEventListener('transitionend', checkIndex);
  }

  sliderItems.style.left = -slider.offsetWidth + "px";
  slide(slider, sliderItems, prev, next);
}

controller.add('image-slider', imageSlider);